// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage"; 
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const db = firestore; // Alias for firestore as 'db'
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const analytics = getAnalytics(app);

// Helper to check if in development mode
export const isDevelopment = process.env.REACT_APP_ENVIRONMENT === 'development';

// Helper to check if debugging is enabled
export const isDebugMode = process.env.REACT_APP_SHOW_DEBUG === 'true';

// Admin email validation
export const getAdminEmails = () => {
  const adminEmails = process.env.REACT_APP_ADMIN_EMAILS || '';
  return adminEmails.split(',').map(email => email.trim().toLowerCase());
};

// Connect to local emulators if enabled by environment variable
const useEmulators = process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true';

if (isDevelopment && window.location.hostname === "localhost" && useEmulators) {
  console.log('🚧 Connecting to local Firebase emulators');
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(firestore, "localhost", 8081);
  connectStorageEmulator(storage, "localhost", 9199);
} else {
  console.log('🔥 Connected to production Firebase');
}

export default app;